import { FileObject } from '@citruscamps/citrus-client'
import React from 'react'
import { Pagination } from '../../../interfaces/pagination'
import { Checkbox } from '../../Checkbox/Checkbox'
import { PageSelector } from '../../PageSelector/PageSelector'
import { TruncatedText } from '../../TruncatedText/TruncatedText'
import { LoadingImageThumbnails } from './LoadingImageThumbnails'

interface IProps {
  value?: FileObject
  images: FileObject[]
  loading?: boolean
  pagination: any
  onChangePage: (pagination: Pagination) => void
  onSelect?: (image?: FileObject) => void | Promise<void>
}

export const ImagePicker = ({
  value,
  images,
  pagination,
  loading = false,
  onChangePage,
  onSelect: handleSelect,
}: IProps) => {
  if (loading && images.length === 0) {
    return <LoadingImageThumbnails {...pagination} />
  }
  if (images.length === 0) {
    return (
      <div className="row text-body-secondary justify-content-center my-5 text-center">
        <div className="col-10 col-md-8 col-lg-6">
          <p>There are no files associated to your program, upload files to see files here.</p>
        </div>
      </div>
    )
  }
  return (
    <div className="img-selector">
      {images.map((image: FileObject) => {
        const isSelected = !!value?.id && image.id === value.id
        return (
          <div
            className={`img-select-item${isSelected ? ' selected' : ''}`}
            key={image.id}
            onClick={() => handleSelect?.(image)}
          >
            <Checkbox checked={isSelected} className="form-control-lg img-select-icon" />
            <img src={image.url} alt={image.title} className="img-thumbnail" />
            <TruncatedText className="img-select-text">{image.filename}</TruncatedText>
          </div>
        )
      })}
      {loading && <LoadingImageThumbnails {...pagination} />}
      <PageSelector size="sm" {...pagination} onChange={onChangePage} />
    </div>
  )
}
